const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBProgressDispatched(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-progress-dispatched",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconB-progress-dispatched1",
    serifid: "iconB-progress-dispatched"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1c6.071,0 11,4.929 11,11c0,6.071 -4.929,11 -11,11c-6.071,0 -11,-4.929 -11,-11c-0,-6.071 4.929,-11 11,-11Zm0,1.986c-4.975,0 -9.014,4.039 -9.014,9.014c0,4.975 4.039,9.014 9.014,9.014c4.975,-0 9.014,-4.039 9.014,-9.014c-0,-4.975 -4.039,-9.014 -9.014,-9.014Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.697,17.855c-1.807,-2.849 -2.177,-6.365 -1.081,-9.552c-0,-0.001 0,-0.002 0.001,-0.003c0.19,-0.596 0.784,-0.75 1.197,-0.618c0.391,0.125 0.894,0.646 0.691,1.307c-0.867,2.814 -0.545,5.875 1.211,8.279c0.369,0.504 0.779,0.96 1.223,1.365c0.605,0.541 1.27,1.005 1.981,1.374c1.248,0.638 2.624,0.976 4.013,0.992c5.004,0 9.061,-4.014 9.061,-9.019c-0,-4.74 -3.665,-8.589 -8.301,-8.98c-0.531,-0.035 -0.943,-0.475 -0.944,-1.007l-0,-0.003c-0,-0.276 0.125,-0.54 0.325,-0.729c0.201,-0.188 0.471,-0.286 0.745,-0.269c0.002,-0 0.003,-0 0.004,-0c3.496,0.289 6.542,2.187 8.367,4.957c0.079,0.065 0.148,0.143 0.204,0.23c0.001,0.001 0.001,0.002 0.002,0.003c2.972,4.863 1.813,11.273 -2.871,14.696c-1.994,1.456 -4.306,2.144 -6.592,2.122c-3.647,-0 -7.004,-1.826 -9.068,-4.786c-0.001,-0.001 -0.001,-0.002 -0.002,-0.003c-0.085,-0.117 -0.138,-0.237 -0.166,-0.356Zm11.99,-6.855l-1.786,-1.786c-0.181,-0.181 -0.292,-0.431 -0.292,-0.707c-0,-0.552 0.447,-1 1,-1c0.276,0 0.526,0.112 0.707,0.293l3.493,3.493c0.181,0.181 0.292,0.431 0.292,0.707c0,0.276 -0.111,0.526 -0.292,0.707l-3.493,3.493c-0.181,0.181 -0.431,0.293 -0.707,0.293c-0.275,-0 -0.523,-0.11 -0.704,-0.289c-0.001,-0.001 -0.002,-0.003 -0.003,-0.004c-0.181,-0.181 -0.293,-0.431 -0.293,-0.707c-0,-0.276 0.112,-0.526 0.292,-0.707l1.786,-1.786l-7.788,0c-0.553,0 -1,-0.448 -1,-1c-0,-0.552 0.447,-1 1,-1l7.788,0Z",
    style: {
      fill: "#01b800"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBProgressDispatched);
export default __webpack_public_path__ + "static/media/iconB-progress-dispatched.48644b9aabe995e6821ff93f896f742d.svg";
export { ForwardRef as ReactComponent };